import { cardsOfCourse, dueCount, scopeLabel, scopedCards } from '../core/load.js';
import { state } from '../core/state.js';
import { $, $$, DAY, dayKey, esc, fromKey, startOfDay } from '../core/text.js';
import { streakDays } from '../progress/streak.js';
import { toast } from '../ui/toast.js';
import { examModal } from './exams.js';

/* ══════════ Version 2 – Dashboard-Redesign (umschaltbar) ══════════ */
export function initDesign() {
  // Klassisches Design entfernt – das neue Design ist ab jetzt Standard.
  document.body.classList.add('design-v2');
  localStorage.setItem('design', 'v2');
}
export function applyDark(on) {
  document.body.classList.toggle('dark', on);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', on ? '#241a2b' : '#f6e0f5');
}
// Manuelle Wahl (persistiert) – überschreibt ab dann die Systemeinstellung.
export function setDark(on) { applyDark(on); localStorage.setItem('dark', on ? '1' : '0'); }
export function initDark() {
  const saved = localStorage.getItem('dark');
  const mq = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
  // Ohne manuelle Wahl folgt die App der Systemeinstellung (ohne sie zu speichern).
  applyDark(saved === null ? !!(mq && mq.matches) : saved === '1');
  if (mq && mq.addEventListener) {
    mq.addEventListener('change', (e) => {
      if (localStorage.getItem('dark') === null) { applyDark(e.matches); const c = document.getElementById('opt-dark'); if (c) c.checked = e.matches; }
    });
  }
}
/* DSGVO-Datenauskunft: alles Persönliche als eine JSON-Datei */
export function dsgvoExport() {
  const data = {
    exportiert_am: new Date().toISOString(),
    hinweis: 'Vollständige Kopie deiner in mimorio gespeicherten Daten (DSGVO Art. 20 – Datenübertragbarkeit).',
    konto: { id: state.me?.id || null, nutzername: state.me?.username || null, email: state.me?.email || null },
    profil: state.profile,
    fortschritt: state.progress,
    ziele: state.goals,
    kalender: state.cal,
    kurse: state.courses,
    vorlesungen: state.decks,
    karten: state.cards,
    protokoll: state.log,
  };
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `mimorio-meine-daten-${dayKey()}.json`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
  toast('Deine Daten wurden heruntergeladen ✦');
}
export function ringSVG(pct) {
  const r = 42, c = 2 * Math.PI * r, off = c * (1 - pct / 100);
  return `<svg viewBox="0 0 100 100" width="100%" height="100%" role="img" aria-label="${pct}% des Tagesziels">
    <circle cx="50" cy="50" r="${r}" fill="none" stroke="var(--lilac-lt)" stroke-width="10"/>
    <circle cx="50" cy="50" r="${r}" fill="none" stroke="var(--lilac)" stroke-width="10" stroke-linecap="round"
      stroke-dasharray="${c.toFixed(1)}" stroke-dashoffset="${off.toFixed(1)}" transform="rotate(-90 50 50)" style="transition:stroke-dashoffset .6s"/>
    <text x="50" y="57" text-anchor="middle" font-size="22" font-weight="800" fill="var(--ink)">${pct}%</text>
  </svg>`;
}
export function renderV2Exam(course) {
  const body = $('#v2-exam-body'); if (!body) return;
  if (!course || !course.examDate) {
    body.innerHTML = `<div class="v2-empty-title">Noch keine Klausur eingetragen</div>
      <div class="v2-empty-text">Lege einen Termin fest und mimorio berechnet dein tägliches Lernziel automatisch.</div>
      <button class="v2-greenbtn" id="v2-exam-btn">Klausur eintragen</button>`;
    const b = $('#v2-exam-btn'); if (b) b.onclick = () => { if (!state.selCourse) { toast('Wähl erst einen Kurs links'); return; } examModal(); };
    return;
  }
  const cards = cardsOfCourse(course.id);
  const open = cards.filter((c) => c.level !== 'green').length;
  const days = Math.max(0, Math.ceil((fromKey(course.examDate).getTime() - startOfDay()) / DAY));
  const perDay = days > 0 ? Math.ceil(open / days) : open;
  body.innerHTML = `<div class="v2-empty-title">${esc(course.name)} · ${days === 0 ? 'heute!' : days + ' Tag' + (days === 1 ? '' : 'e')}</div>
    <div class="v2-empty-text">${open} Karten offen · Tagesziel ${open ? perDay : '✓'} · Klausur am ${fromKey(course.examDate).toLocaleDateString('de', { weekday: 'long', day: 'numeric', month: 'long' })}</div>
    <button class="v2-greenbtn" id="v2-exam-btn">Termin ändern</button>`;
  const b = $('#v2-exam-btn'); if (b) b.onclick = examModal;
}
export function syncSeg(sel, attr, val) { $$(sel + ' .v2-segbtn').forEach((b) => b.classList.toggle('active', b.dataset[attr] === val)); }
export function renderDashboardV2() {
  const cards = scopedCards();
  const course = state.courses.find((c) => c.id === state.selCourse);
  const by = (l) => cards.filter((c) => c.level === l).length;
  const total = cards.length, green = by('green'), yellow = by('yellow'), red = by('red');
  const due = dueCount(cards);
  const todayCount = state.log.find((l) => l.day === dayKey())?.count || 0;

  $('#v2-title').textContent = course ? course.name : 'Übersicht';
  $('#v2-sub').textContent = course ? `${total} Karte${total === 1 ? '' : 'n'} im aktuellen Bereich` : 'Wähle links einen Kurs oder eine Vorlesung.';

  renderV2Exam(course);

  const pct = total ? Math.round(green / total * 100) : 0;
  $('#v2-pct').textContent = pct + ' %';
  $('#v2-bar').style.width = pct + '%';
  $('#v2-barnote').textContent = `${green} von ${total} Karten sind grün`;
  $('#v2-progstats').innerHTML = [[due, 'jetzt fällig'], [total, 'insgesamt'], [todayCount, 'heute'], [green, 'sicher gelernt']]
    .map(([n, l]) => `<div class="v2-stat"><b>${n}</b><span>${l}</span></div>`).join('');

  const pctOf = (n) => total ? Math.round(n / total * 100) : 0;
  $('#v2-status').innerHTML = [
    { cls: 'red', c: 'var(--rose)', name: 'Noch unsicher', n: red },
    { cls: 'yellow', c: 'var(--butter)', name: 'Fast gelernt', n: yellow },
    { cls: 'green', c: 'var(--lilac)', name: 'Sicher gelernt', n: green },
  ].map((s) => `<div class="v2-scard ${s.cls}">
      <span class="v2-sdot" style="background:${s.c}"></span>
      <div class="v2-snum">${s.n}</div><div class="v2-sname">${s.name}</div>
      <div class="v2-sdesc">${pctOf(s.n)} % des Stapels</div>
      <div class="v2-sbar"><i style="width:${pctOf(s.n)}%;background:${s.c}"></i></div></div>`).join('');

  const goal = state.goals.daily || 20;
  const dp = Math.min(100, Math.round(todayCount / goal * 100));
  $('#v2-ring').innerHTML = ringSVG(dp);
  $('#v2-daily-frac').textContent = `${todayCount} / ${goal}`;

  const sd = streakDays();
  $('#v2-streak-days').textContent = sd;
  $('#v2-milestones').innerHTML = [3, 7, 14, 30].map((m) => `<div class="v2-ms ${sd >= m ? 'done' : ''}"><span class="v2-msdot"></span><span class="v2-mslbl">${m} Tage</span></div>`).join('');

  const exams = state.courses.filter((c) => c.examDate).sort((a, b) => a.examDate.localeCompare(b.examDate));
  const next = exams.find((c) => fromKey(c.examDate).getTime() >= startOfDay()) || exams[0];
  if (next) {
    const d = Math.max(0, Math.ceil((fromKey(next.examDate).getTime() - startOfDay()) / DAY));
    $('#v2-nextexam').innerHTML = `<div class="v2-cardline"><img src="assets/icon_calendar.png" alt="">
      <div><div class="v2-cardsmall">NÄCHSTE KLAUSUR</div><div class="v2-cardbig">${esc(next.name)}</div>
      <div class="v2-cardsmall">${d === 0 ? 'heute' : d + ' Tag' + (d === 1 ? '' : 'e')} · ${fromKey(next.examDate).toLocaleDateString('de', { day: 'numeric', month: 'long' })}</div></div>
      <span class="v2-arrow">→</span></div>`;
  } else {
    $('#v2-nextexam').innerHTML = `<div class="v2-cardline"><img src="assets/icon_calendar.png" alt="">
      <div><div class="v2-cardsmall">NÄCHSTE KLAUSUR</div><div class="v2-cardbig">Keine Klausur geplant</div>
      <div class="v2-cardsmall">Trag einen Termin im Kalender ein.</div></div><span class="v2-arrow">→</span></div>`;
  }

  $('#v2-duetoday').innerHTML = due
    ? `<div class="v2-cardline"><img src="assets/icon_target.png" alt="">
        <div><div class="v2-cardsmall">HEUTE FÄLLIG</div><div class="v2-cardbig">${due} Karte${due === 1 ? '' : 'n'} dran</div>
        <div class="v2-cardsmall">Jetzt wiederholen, solange sie frisch sind.</div></div><span class="v2-arrow">→</span></div>`
    : `<div class="v2-cardline"><img src="assets/cat_happy.png" alt="" class="pixel-art">
        <div><div class="v2-cardsmall">HEUTE FÄLLIG</div><div class="v2-cardbig">Nichts fällig 🎉</div>
        <div class="v2-cardsmall">Genieß den Tag oder wiederhole freiwillig.</div></div></div>`;

  syncSeg('#v2-studymode', 'studymode', state.studyMode);
  syncSeg('#v2-mode', 'mode', state.mode);
  syncSeg('#v2-focus', 'focus', state.focus);
  syncSeg('#v2-size', 'size', String(state.size));
  $('#v2-scopenote').textContent = scopeLabel();
  $('#v2-start').disabled = !cards.length;
}

